import { AssessmentResultRecordType } from "../types";

export default function getStudentGrade(
  assessment: AssessmentResultRecordType
) {
  return assessment.student.grade;
}
